import * as React from 'react';

// COMPONENTS
import Button from './Button';
import StatusIcon from './StatusIcon';
import GlobalModal from './GlobalModal';
import AddDocumentModal from '../pages/StaffProfile/AddDocumentModal';
import CitedDocumentModal from '../pages/StaffProfile/CitedDocumentModal';

// ICONS
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';

// TYPES
import { StaffFetchDocument } from '../api/models';

interface ProfileCertificationsTypes {
	certifications?: Array<StaffFetchDocument>;
	defaultMaxItems?: number;
	referenceChecks?: Array<StaffFetchDocument>;
	staffId?: string;
	canUpdate?: boolean;
	didUpdate?: React.Dispatch<React.SetStateAction<boolean>>;
	getStaffProfileData: () => Promise<void>;
	isYou: boolean | undefined;
}

const ProfileCertifications: React.FC<ProfileCertificationsTypes> = ({
	certifications,
	defaultMaxItems,
	referenceChecks,
	staffId,
	canUpdate,
	isYou,
	didUpdate,
	getStaffProfileData
}) => {
	const [maxCertificationsItem, setMaxCertificationsItem] = React.useState<number>(defaultMaxItems || 5);

	const [showAddDocumentModal, setShowAddDocumentModal] = React.useState<boolean>(false);

	const [showCitedDocumentModal, setShowCitedDocumentModal] = React.useState<boolean>(false);

	const [currentFormID, setCurrentFormId] = React.useState<string>('');

	const [currentFormModal, setCurrentFormModal] = React.useState<string>('');

	const [modalMounted, setModalMounted] = React.useState<boolean>(false);

	const certificationJoin =
		isYou && !canUpdate
			? certifications && [...certifications]
			: canUpdate && certifications
			? referenceChecks && certifications && [...referenceChecks!, ...certifications!]
			: [...referenceChecks!];

	React.useEffect(() => {
		setModalMounted(true);
	}, []);

	React.useEffect(() => {
		if (!showCitedDocumentModal && modalMounted) {
			didUpdate!(true);
		}
	}, []);

	const viewCertification = (item: any) => {
		if (item.displayName === 'Reference checks') {
			setCurrentFormModal(item.displayName || '');

			setCurrentFormId(item.id || '');

			setShowAddDocumentModal(true);
		} else {
			setShowCitedDocumentModal(true);

			setCurrentFormModal(item.displayName || '');

			setCurrentFormId(item.id || '');
		}
	};

	return (
		<>
			{certificationJoin && certificationJoin.length > 0 && (
				<section className="info-section">
					<div className="section-header">
						<h2 className="header-name color-dark">Documents</h2>
					</div>

					{certificationJoin.slice(0, maxCertificationsItem).map((item, index) => {
						return (
							<div key={index} className="row-container">
								<div className="row detail-row">
									<div className="col-auto pdl-0 pdr-0">
										<StatusIcon statusType={item.status || 'Error'} />
									</div>

									<div className="col-md-auto col-lg-10 full-width">
										<div className="row detail-info">
											<div className="col-lg-4 detail-name">{item.displayName}</div>

											<div className="col-lg-8 detail-status">
												<span className={`label ${item.status?.toLowerCase()}`}>{item.statusLabel}</span>
											</div>
										</div>
									</div>

									<div className="col-auto pdr-0 link-group">
										{canUpdate && item.status === 'Error' && item.displayName === 'Reference checks' && !isYou ? (
											<Button
												className="btn-text"
												type="button"
												onClick={() => {
													setShowAddDocumentModal(true);
													setCurrentFormModal(item.displayName || '');
													setCurrentFormId('');
												}}
											>
												Add
											</Button>
										) : item.displayName === 'Reference checks' && isYou ? null : (
											<Button
												className="btn-text"
												type="button"
												onClick={() => {
													viewCertification(item);
												}}
											>
												View
											</Button>
										)}
									</div>
								</div>
							</div>
						);
					})}

					{certificationJoin && certificationJoin.length > 0 && maxCertificationsItem < certificationJoin.length && (
						<Button
							className="btn-secondary btn-show-more"
							onClick={() => setMaxCertificationsItem(certificationJoin.length)}
							buttonIcon={<PlusIcon className="link-icon" />}
						>
							Show {certificationJoin.length - maxCertificationsItem} more
						</Button>
					)}
				</section>
			)}

			<GlobalModal titleText={currentFormModal} isOpen={showAddDocumentModal} setIsOpen={setShowAddDocumentModal}>
				<AddDocumentModal
					formType={currentFormModal}
					staffId={staffId}
					getStaffProfileData={getStaffProfileData}
					currentFormID={currentFormID}
				/>
			</GlobalModal>

			<GlobalModal isOpen={showCitedDocumentModal} titleText={currentFormModal} setIsOpen={setShowCitedDocumentModal}>
				<CitedDocumentModal
					update={getStaffProfileData}
					canUpdate={canUpdate}
					isYou={isYou}
					setTitle={setCurrentFormModal}
					formId={currentFormID}
				/>
			</GlobalModal>
		</>
	);
};

export default ProfileCertifications;
